<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '',
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['selectLabel'],

  methods: {
    onClick() {
      this.$emit('selectLabel', this.title);
    },
  },
};
</script>

<template>
  <div 
    class="flex items-center px-2 py-2 mx-1 my-0.5 rounded cursor-pointer hover:bg-slate-50 dark:hover:bg-slate-600 transition-colors"
    @click="onClick"
  >
    <div class="flex items-center flex-grow min-w-0">
      <div
        v-if="color"
        class="w-3 h-3 rounded-full mr-2 flex-shrink-0"
        :style="{ backgroundColor: color }"
      />
      <span class="text-sm text-slate-700 dark:text-slate-200 truncate" :title="title">{{ title }}</span>
    </div>
    <div v-if="selected" class="text-slate-500 dark:text-slate-400 ml-2">
      <i class="i-lucide-circle-check text-sm" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
/* Styles moved to template classes */
</style>
